import { ProjectMenuContainer } from 'blaze-components/ProjectMenu/ProjectMenuContainer'
import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'

interface Props extends DrawerProps {
  folderId: string
}

export const ProjectMenuDrawer = observer(({ folderId, ...props }: Props) => {
  const { drawersStore } = useRootStore()

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>More Options</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <ProjectMenuContainer
                menuType="tray"
                id={folderId}
                hiddenKeys={new Set(['rename', 'move', 'updateMetadata'])}
                dismiss={() => drawersStore.closeDrawer()}
                onAction={() => drawersStore.closeDrawer()}
              />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
